import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadReconcileAtom = createMutationAtomFactory(
  'trade.loadReconcile',
  (params: { id: string; invoiceId?: string }) => ({
    tradeLoadReconcile: {
      __args: {
        id: params.id,
        invoiceId: params.invoiceId,
      },
      id: true,
    },
  }),
);
